


































import { Vue, Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import BasicList from '@/components/lists/BasicList.vue'
import AddDialog from '@/components/dialogs/AddDialog.vue'
import InvestigationModel from '@/models/investigation/investigationModel'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import Validation from '@/mixins/validation'
import { getModule } from 'vuex-module-decorators'
import ExtensionModule from '@/store/extensionModule'

const extensionModule = getModule(ExtensionModule)

@Component({
  components: {
    BasicList,
    AddDialog
  }
})
export default class Home extends Mixins(Validation) {
  @Prop(String) readonly id!: string

  private dialog: boolean = false
  private valid: boolean = true
  private investigations: Array<InvestigationModel> = []
  private investigation: InvestigationModel = new InvestigationModel()
  private isEdit: boolean = false

  created() {
    this.subscribeToModalOpen()
    this.getInvestigations()
  }

  private subscribeToModalOpen(): void {
    this.$root.$on('openNavbarModal', () => {
      if (this.id) {
        this.dialog = true
      }
    })
  }

  private async getInvestigations(): Promise<void> {
    if (this.id) {
      this.investigations = await ApiService.getAllById<InvestigationModel>(
        UrlType.InvestigationExtension,
        this.id
      )
    }
  }

  private async postInvestigation(valid: boolean): Promise<void> {
    if (valid) {
      this.investigation.extensionId = this.id
      if (this.isEdit) {
        await ApiService.put<InvestigationModel>(
          UrlType.Investigation,
          this.investigation.extensionInvestigationId,
          this.investigation
        )
      } else {
        await ApiService.post<InvestigationModel>(
          UrlType.Investigation,
          this.investigation
        )
      }
      this.dialog = false
      this.isEdit = false
      this.getInvestigations()
    }
  }

  private navigate(investigation: InvestigationModel): void {
    this.$router.push({
      name: 'investigation',
      params: { id: investigation.extensionInvestigationId }
    })
  }

  private editInvestigation(investigation: InvestigationModel) {
    this.investigation = Object.assign({}, investigation)
    this.isEdit = this.dialog = true
  }

  private async deleteInvestigation(
    investigation: InvestigationModel
  ): Promise<void> {
    const confirm = window.confirm(
      'Are you sure you would like to delete this investigation? Any related data will be deleted.'
    )

    if (confirm) {
      await ApiService.delete(
        UrlType.Investigation,
        investigation.extensionInvestigationId
      )
      await this.getInvestigations()
    }
  }

  @Watch('id', { immediate: true })
  onIdChanged() {
    if (this.id) {
      extensionModule.fetchExtension(this.id)
      this.getInvestigations()
    }
  }
}
